<template>
  <div>
    <div :class="className" @click="funcCustomer"> 

    </div>
    <router-view />
  </div>
</template>
<script>
export default {
  data(){
    return{
      className:'news_kefu',
    }
  },
   watch: {
        $route(to, from) {
            if(to.fullPath.indexOf('/exam_appointment')!=-1){
              this.className = "news_kefu news_kefuNone"
            }else{
              this.className = "news_kefu"
            }
        },
    },
  methods:{
    //在线客服
    funcCustomer(){
      console.log(this.$route);
       window.open("https://1382135.s2.udesk.cn/im_client/?web_plugin_id=29918")
     },
  }
}
</script>
<style lang="scss">
  .news_kefu {
    width: 75px;
    height: 75px;
    background: url("../static/images/imgs/kefudig.png") no-repeat center;
    background-size: 75px 75px;
    position:fixed;
    right: 50px;
    top: 100px;
    cursor: pointer;
    z-index: 10;
}
.news_kefuNone{
  display:none;
}
*{margin:0;padding:0;touch-action: pan-y;}
// html{
//   // width: 100%;
// }
html{
   touch-action:none;
}
body{
  overflow-y: overlay;
  // width: 100%;
  
}
ul li{
  list-style: none;
}
// .wrap{
//   // background-color: #fff;
// }
.wrap .query-banner{
  height: 400px;
  background-image: url("./assets/cjyzscx.png");
  text-align: center;
  line-height: 400px;
  p{
    font-size: 48px;
    font-weight: 400;
    color: #fff;
  }
}
#app{
  height: 100%;
}
::-webkit-scrollbar{width: 6px;height: 6px;}
::-webkit-scrollbar-thumb{background: #666;border-bottom: 1px solid #333;border-top: 1px solid #333;}
::-webkit-scrollbar-track{background: #dedede;border-left: 0.5px solid #cdcddd;}
</style>
